import { Routes, RouterModule } from '@angular/router';

import { CheckinComponent } from './checkin.component';
import { MainLayoutComponent } from 'src/app/shared/layouts/main-layout/main-layout.component';
import { BookingGuard } from 'src/app/shared/guards/booking/booking.guard';
import { CardGuard } from 'src/app/shared/guards/card/card.guard';
import { StaticPageLayoutComponent } from 'src/app/shared/layouts/static-page-layout/static-page-layout.component';
import { ERoutes } from 'src/app/shared/enums/routes.enum';
import { FallbackDomainComponent } from '../../../shared/common/components/fallback-domain/fallback-domain.component';
import { BaseGuard } from '../../../shared/guards/base/base.guard';

const routes: Routes = [
  {
    path: ERoutes.TERMS,
    component: StaticPageLayoutComponent,
    children: [{
      path: '',
      loadChildren: () => import('./pages/terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule)
    }]
  },
  {
    path: ERoutes.SEARCH,
    loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingModule)
  },
  {
    path: ':hash',
    canActivate: [BookingGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: CheckinComponent,
        children: [{
          path: ERoutes.BOOKING,
          loadChildren: () => import('../../../shared/pages/booking/booking.module').then(m => m.BookingModule)
        }, {
          path: ERoutes.CARD,
          canActivate: [CardGuard],
          loadChildren: () => import('../../../shared/pages/link-card/link-card.module').then(m => m.LinkCardModule)
        }, {
          path: '',
          loadChildren: () => import('./pages/guests/guests.module').then(m => m.GuestsModule)
        }, {
          path: ':occupantId',
          loadChildren: () => import('./pages/wizard/wizard.module').then(m => m.WizardModule)
        }]
      }
    ]
  },
  { path: '', component: FallbackDomainComponent }
];

export const CheckinRoutingModule = RouterModule.forChild(routes);
